import { createApi } from '@reduxjs/toolkit/query/react';
import { serviceBaseQuery } from './baseQuery';

export const apiTagTypes = [
    'Account',
    'AccountMfaSettings',
    'AccountSetting',
    'Group',
    'GroupList',
    'MfaCompanySetting',
    'Role',
    'Tag',
    'User',
    'UserList',
] as const;

export const baseApi = createApi({
    reducerPath: 'api',
    baseQuery: serviceBaseQuery,
    tagTypes: apiTagTypes,
    endpoints: () => ({}),
});
